import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const login = (userName, passWord, validateCode) => {
  return api.post(`${ApiEndpointConstants.LOGIN}`, {
    userName,
    passWord,
    validateCode,
  });
};
